import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'asistencia-alertas-barra',
    standalone: false,
    template: `
        <div class="header-mainInfo">
            <h1 class="control-item">Asistencia</h1>
            <span class="header-mainInfo__separator">/</span>
            <h1 class="">Alumnos con alerta</h1>
            <span class="spacer"></span>
        </div>`
})

export class AsistenciaAlertasBarraComponent implements OnInit {

    constructor() {
    }

    ngOnInit() {
    }
}